"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function reportScriptSupplierError(reportAction, reportError, consentLocale) {
  const url = window.location.href;
  fetch('https://ucmapi.americanexpress.com/api/consent/management/report/error', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-locale': `${consentLocale}`,
      'x-url': `${url}`
    },
    body: JSON.stringify({
      action: reportAction,
      error: reportError
    })
  }).catch( /* istanbul ignore next */() => {
    // Swallow error
  });
}
var _default = reportScriptSupplierError;
exports.default = _default;